var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"questionnaire-question"},[_c('h6',{staticClass:"question-title"},[_vm._v("\n        "+_vm._s(_vm.questionIn.question)+"\n    ")]),_vm._v(" "),_c('design-2021-questionnaire-answer-component',{on:{"input":_vm.updateQuestion},model:{value:(_vm.answer),callback:function ($$v) {_vm.answer=$$v},expression:"answer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }